import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import Client1 from '../img/client/s0.png';
import Client2 from '../img/client/s1.png';
import Client3 from '../img/client/s2.png';
import Client4 from '../img/client/s3.png';
import Client5 from '../img/client/s4.png';
import Client6 from '../img/client/s5.png';
import Client7 from '../img/client/s6.jpg';
import Client8 from '../img/client/s7.jpg';
import Client9 from '../img/client/s8.png';
import Client10 from '../img/client/s9.png';
import Client12 from '../img/client/s16.png';
import Client13 from '../img/client/s11.png';
import Client14 from '../img/client/s12.png';
import Client15 from '../img/client/s13.jfif';
import Client16 from '../img/client/s14.jfif';
import Client17 from '../img/client/uro.jfif';
import Client18 from '../img/client/s20.png';
import Client19 from '../img/client/s15.jpeg';

const clientLogos = [
  { src: Client1, alt: 'Client Logo 1' },
  { src: Client2, alt: 'Client Logo 2' },
  { src: Client3, alt: 'Client Logo 3' },
  { src: Client4, alt: 'Client Logo 4' },
  { src: Client5, alt: 'Client Logo 5' },
  { src: Client6, alt: 'Client Logo 6' },
  { src: Client7, alt: 'Client Logo 7' },
  { src: Client8, alt: 'Client Logo 8' },
  { src: Client9, alt: 'Client Logo 9' },
  { src: Client10, alt: 'Client Logo 10' },
  { src: Client12, alt: 'Client Logo 12' },
  { src: Client13, alt: 'Client Logo 13' },
  { src: Client14, alt: 'Client Logo 14' },
  { src: Client15, alt: 'Client Logo 15' },
  { src: Client16, alt: 'Client Logo 16' },
  { src: Client17, alt: 'Client Logo 17' },
  { src: Client18, alt: 'Client Logo 18' },
  { src: Client19, alt: 'Client Logo 19' },
];

const LogoSlider = () => {
  return (
    <Container>
      <Title>Our Valuable Clients</Title>
      <Track direction="left">
        {/* Original logos */}
        {clientLogos.map((logo, index) => (
          <Logo key={`left-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </Logo>
        ))}
        {/* Duplicate logos for seamless loop */}
        {clientLogos.map((logo, index) => (
          <Logo key={`left-dup-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </Logo>
        ))}
      </Track>

  {/*       <Track direction="left">
        {[...clientLogos, ...clientLogos].map((logo, index) => (
          <Logo key={`left-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </Logo>
        ))}
      </Track> */}
      
      {/* Right scrolling track (if needed) */}
      <Track direction="right">
        {[...clientLogos, ...clientLogos].map((logo, index) => (
          <Logo key={`right-${index}`}>
            <img src={logo.src} alt={logo.alt} />
          </Logo>
        ))}
      </Track>
    </Container>
  );
};

export default LogoSlider;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 20px;
  font-weight: 600;
  color: #0ab5d3ff;
`
// Animation for left scroll
const scrollLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

// Container for the entire component
const Container = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 2rem 0;
  background: #f8f9fa; /* Optional: Add background for better visibility */
`;

// Styled component for the track
/* const Track = styled.div`
  display: flex;
  white-space: nowrap;
  animation: ${scrollLeft} 25s linear infinite;
  width: max-content;

  &:hover {
    animation-play-state: paused;
  }
`; */

// Styled component for each individual logo
const Logo = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 3rem;
  flex-shrink: 0; /* Prevent logos from shrinking */

  img {
    height: 60px; /* Fixed height for consistency */
    width: auto;
    max-width: 120px; /* Maximum width */
    object-fit: contain;
    //filter: grayscale(100%);
    transition: all 0.3s ease;
    mix-blend-mode: multiply;
    &:hover {
      filter: grayscale(0%);
      transform: scale(1.1);
    }
  }
`;

const scrollRight = keyframes`
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
`;

// Then modify Track to handle direction prop:
const Track = styled.div`
  display: flex;
  white-space: nowrap;
  width: max-content;
  animation: ${props => props.direction === 'left' ? scrollLeft : scrollRight} 25s linear infinite;
  margin-bottom: 20px;
  
  &:hover {
    animation-play-state: paused;
  }
`;